import React from 'react'
import styled from "styled-components";
import { animated } from "react-spring";
import { withRouter, Link } from "react-router-dom"
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import { Flex } from "../../styles/GlobalStyle.js";
import Property from "../../model/property";
import { updateViFontStatus } from "../../utils/vietnameseFontHelper";
import { get, sortBy, isNull } from "lodash"

class TopBar extends React.Component {

  constructor(props) {
    super(props);
    this.categoryTopRef = []
  }

  state = {
    title: "",
    dataSource: [],
    indexCategory: 0,
    anchorEl: null
  }

  handleClick() {
    Property.popPreviousTitle()
  }
  
  handleClickBackButton() {
    window.ReactNativeWebView.postMessage("navigation_back")
  }

  scrollToCategoryTopRef = (index) => {
    const elementId = document.getElementById(`listId`);
    elementId.scrollTo(get(this.categoryTopRef[index], 'offsetLeft', 50) - 50, 0)
    this.setState({ indexCategory: index })
  }

  componentDidUpdate(prevProps) {
    updateViFontStatus();
    if (this.props.sections !== prevProps.sections) {
      const dataSource = sortBy(this.props.sections,['position','id'])
      this.setState({ dataSource })
    }
    if (this.props.categoryTopIndex !== prevProps.categoryTopIndex) {
      this.scrollToCategoryTopRef(this.props.categoryTopIndex)
    }
  }

  componentDidMount() {
    updateViFontStatus();
    if (this.props.sections) {
      const dataSource = sortBy(this.props.sections,['position','id']);
      this.setState({ dataSource })
    }
  }

  renderBackTitle() {
    const preset = Property.getPreset()
    return (
      <FlexContainer>
        <Flex flex={1} container alignItems={"center"} className={'headerStyle'}>
          <Link to={{ pathname: `${this.props.previousUrl}` }} onClick={this.handleClick.bind(this)}>
            <ArrowBackIos style={{ fontSize: 20, color: `${get(preset, 'app_home_text_top_nav', 'white')}`, width: 50 }} />
          </Link>
          <Title app_home_text_top_nav={preset.app_home_text_top_nav} className={'textTitle'}>{this.props.previousTitle.toUpperCase()}</Title>
        </Flex>
      </FlexContainer>
    )
  }

  render() {
    const preset = Property.getPreset()
    const search = this.props.location.search
    const params = new URLSearchParams(search)
    const accessToken = params.get('access_token')
    const accessByMobile = (!isNull(Property.getAccessToken()) || !isNull(accessToken))
    const brandStyle = preset.app_brand_stylesheet
    return (
      <Navbar app_top_nav_bg_color={preset.app_top_nav_bg_color}>
        {brandStyle ?
            <link href={`${preset.app_brand_stylesheet}`} rel="stylesheet" />
            :<></>
        }
        {this.props.productListPage ?
          <FlexList>
            {this.props.previousTitle ?
              <Link to={{ pathname: `${this.props.previousUrl}`, backFrom: this.props.currentPage, search: this.props.search }} onClick={this.handleClick.bind(this)}>
                <ArrowBackIos style={{ fontSize: 20, color: `${get(preset, 'app_home_text_top_nav', 'white')}`, width: 50 }} />
              </Link>
              : accessByMobile ?
                    <div id={'web_view_nav'} className={'web_view_nav'} onClick={this.handleClickBackButton}>
                      <ArrowBackIos style={{ fontSize: 20, color: `${get(preset, 'app_home_text_top_nav', 'white')}`, width: 50 }} />
                    </div>
                    :<Flex flex={0.5} height={"5rem"}></Flex>
            }
            <ListHideScroll id={"listId"}>
              {
                this.state.dataSource.map((item, index) =>
                  <TitleContainer className={'headerStyle'} ref={(ref) => this.categoryTopRef[index] = ref} onClick={this.props.onPress(index)}
                    key={index} colorOpacity={index === this.state.indexCategory ? true : false}
                    lastItemSpace={index === this.state.dataSource.length - 1 ? true : false}
                    app_home_text_top_nav={preset.app_home_text_top_nav}>
                    <CategoryTitle className={'textTitle'}>
                      {Property.getTitleCapital(item.title)}
                    </CategoryTitle>
                    {index === this.state.indexCategory ?
                      <Border app_home_text_top_nav={preset.app_home_text_top_nav} />
                      : null
                    }
                  </TitleContainer>
                )
              }
            </ListHideScroll>
          </FlexList>
          : this.props.previousTitle ?
            this.renderBackTitle()
            :
            <FlexContainer className={'headerStyle'}>
              {accessByMobile && <div id={'web_view_nav'} className={'web_view_nav'} onClick={this.handleClickBackButton}>
                <ArrowBackIos style={{ fontSize: 20, color: `${get(preset, 'app_home_text_top_nav', 'white')}`, width: 50 }} />
              </div>}
              <Title app_home_text_top_nav={preset.app_home_text_top_nav} className={'textTitle'}>{Property.getTitleCapital(this.props.title)}</Title>
            </FlexContainer>
        }
      </Navbar>
    )
  }
}

export default withRouter(TopBar)

const List = styled.div`
  overflow: auto;
  white-space: nowrap;
  flex: 4;
`;

const CategoryTitle = styled.div`
  font-size: 2rem;
  padding: 0 16px;
`;

const Border = styled.div`
  border-style: none none ridge none;
  border-width: medium;
  border-color: ${(props) => props.app_home_text_top_nav ? props.app_home_text_top_nav : 'white'};
`;

const Title = styled.div`
  margin: 0 0 0 10px;
  text-align: center;
  color: ${(props) => props.app_home_text_top_nav ? props.app_home_text_top_nav : 'white'};
  font-size: 2rem;
`;

const TitleContainer = styled.div`
  text-align: center;
  display: inline-block;
  font-size: 2rem;
  color: ${(props) => props.app_home_text_top_nav ? props.app_home_text_top_nav : 'white'};
  height: 5rem;
  margin-right: ${(props) => props.lastItemSpace ? "10rem" : "0"};
  opacity: ${(props) => props.colorOpacity ? "1" : ".4"};
  line-height: 4.5rem;
`;

const Navbar = styled(animated.nav)`
  width: 100%;
  top: 0;
  left: 0;
  background: ${(props) => props.app_top_nav_bg_color ? props.app_top_nav_bg_color : '#2d3436'};
  position: fixed;
  z-index: 1;
  font-size: 1.4rem;
   #listId::-webkit-scrollbar {
    display: none;
  }
`;

const FlexContainer = styled.div`
  max-width: 120rem;
  display: flex;
  margin: auto;
  padding: 0 0 0 1rem;;
  height: 5rem;
  align-items: center;
`;

const FlexList = styled.div`
  display: flex;
  margin: auto;
  padding: 0 0 0 1rem;
  justify-content: space-between;
  height: 5rem;
  align-items: center;
`;

const ListHideScroll = styled(List)`
  -ms-overflow-style: none;
  scrollbar-width: none; 
`;
